<template>
  <div class="flex sm:flex-row  flex-col bg-white shadow-md rounded relative">
    <div
      class="min-h-full rounded-l w-2"
      :class="entrevista.state_obj && entrevista.state_obj.color"
    ></div>
    <div class="w-full p-4 space-y-1">
      <div> <span class="text-gray-900">#{{entrevista.id }}</span> {{entrevista.nome }}</div>
      <div class="flex space-x-6">
        <div>
          <span class="subtitle">{{entrevista.centro_custo && entrevista.centro_custo.nome}} </span>
        </div>
      </div>
      <div class="flex space-x-6">
        <div>
          <span class="subtitle">Solicitado por {{entrevista.solicitante && entrevista.solicitante.name}} em {{formatDate(entrevista.created_at)}} </span>
        </div>
      </div>
      <div class="flex">
        <div
          v-if="entrevista.codigo_acesso"
          class="p-2 bg-yellow-300  rounded text-center"
        >
          Código de acesso : {{entrevista.codigo_acesso}}
        </div>
        <div
          v-if="entrevista.colaborador_recusou"
          class="p-1 bg-yellow-300  rounded text-center text-xs"
        >
          Colaborador recusou-se a preencher o formulário da Entrevista de Desligamento.
        </div>

      </div>
    </div>

    <div class="absolute right-2 top-2">
      <div class="self-start">
        <jet-dropdown>
          <template #trigger>
            <i class=" cursor-pointer fas  fa-ellipsis-v text-gray-500"></i>
          </template>
          <template #content>
            <jet-dropdown-link :href="route('entrevista.show', entrevista.id)">
              <div> <i class="fa fa-folder-open pr-2"></i> Visualizar</div>
            </jet-dropdown-link>

          </template>
        </jet-dropdown>

      </div>
    </div>

  </div>
</template>

<script>
import JetDropdown from "@/Jetstream/Dropdown";
import JetDropdownLink from "@/Jetstream/DropdownLink";
export default {
  props: ['entrevista'],
  components: { JetDropdown, JetDropdownLink },

}
</script>

<style scoped>
.subtitle {
  font-size: 0.8rem;
}
</style>
